import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import Print from 'vue-print-nb'
import * as filters from './filters' // global filters
import checkPermission from './utils/permission'
Vue.prototype.$checkPermission = checkPermission
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs
// import echarts from 'echarts'
import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts
Vue.use(Print);
// Vue.use(vueEasyPrint);
Vue.use(Element, {
    size: Cookies.get('size') || 'medium' // set element-ui default size
        // locale: enLang // 如果使用中文，无需设置，请删除
})
// 增加 vxe-tabl
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
VXETable.setup({
  zIndex: 999,
  pager: {
    size: null,
    autoHidden: false,
    perfect: true,
    pageSize: 20,
    pagerCount: 7,
    pageSizes: [10, 15, 20, 50, 100],
    layouts: ['PrevJump', 'PrevPage', 'Jump', 'PageCount', 'NextPage', 'NextJump', 'Sizes', 'Total']
  },
})

import EditDownTable from './components/VXE/EditDownTable.vue'
import EditPopupModal from './components/VXE/EditPopupModal.vue'
import EditDownModal from './components/VXE/EditDownModal.vue'

Vue.component(EditDownTable.name, EditDownTable)
Vue.component(EditPopupModal.name, EditPopupModal)
Vue.component(EditDownModal.name, EditDownModal)

// 开始
import DownTable from './components/VXE/DownTable.vue'

Vue.component(DownTable.name, DownTable)
// 结束
// 创建一个下拉表格渲染
VXETable.renderer.add('EditDownTable', {
  autofocus: '.vxe-input--inner',
  renderEdit (h, renderOpts, params) {
    const { props } = renderOpts
    return [
      <edit-down-table params={ params } { ...{ props } }></edit-down-table>
    ]
  }
})

Vue.use(VXETable)
// 给 vue 实例挂载内部对象，例如：
// Vue.prototype.$XModal = VXETable.modal
// Vue.prototype.$XPrint = VXETable.print
// Vue.prototype.$XSaveFile = VXETable.saveFile
// Vue.prototype.$XReadFile = VXETable.readFile

// register global utility filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
if (window.WebfunnyMonitor) {
  const domain = window.location.host;
  let env = process.env.NODE_ENV === 'development' ? 'dev' : (domain.includes('epochwlkj') ? 'pro':'sit');

  WebfunnyMonitor.init({ projectVersion: "1.0.0", env });
  WebfunnyMonitor.initUser({
    userId: store.getters.userid||0, // 用户标识
    userTag: store.getters.mobile // 用户标签
  });
}
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
